<template>
  <div class="nds-cell">
    <span class="nds-cell">
      <span :class="headCell.offer?.is_fake ? 'red' : ''">
        <img
          v-if="headCell.offer?.is_fake"
          class="mr-10"
          src="~@/assets/icon/baseIcons/fictive-bidder.png"
          alt="none"
        >
        {{ formatCurrency(getValueByKey(headCell, row.fieldNameTotalPrice)) }} руб
      </span>

      <span class="nds-cell--light">
        НДС: {{ formatCurrency(getValueByKey(headCell, row.fieldNameTotalVAT)) }} руб  ({{ headCell.nds_counter }}%)
      </span>
    </span>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
import { decoratorProps } from '@/mixin/props'
import { formatCurrency } from '@/utils/format/number'
import { getValueByKey } from '@/utils/utils'

defineProps({
  ...decoratorProps.props
})
</script>

<style lang="scss">
@import "~@/styles/_variables.scss";

.nds-cell {
  display: flex;
  flex-direction: column;
  &--light {
    padding-top: 10px;
    color: $color-gray;
  }
}

.red {
  color: $color-red;
}
</style>
